import React,{useState} from 'react'

//Bibliotecas
import styled from 'styled-components';

//Imágenes
import { UserX, UserPlus, ChevronDown } from 'react-feather'

function SelectOva({options, selection, setSelection, setOvaID}) {
    const [activeDropdown, setActiveDropdown] = useState(false);
  return (
    <DropDown>
            <DropDownButton onClick={(e) => setActiveDropdown(!activeDropdown)}>
                <span>{selection}</span>
                <ChevronDown />
            </DropDownButton>
            {activeDropdown &&
                <DropDownContent>
                    {options.map(opt=>(
                        <DropDownItem
                        key={opt._id}
                        onClick={e=>{setSelection(opt.nombre); setActiveDropdown(false); setOvaID(opt._id)}}>
                           <span>{opt.nombre}</span>
                        </DropDownItem>
                    ))}
                </DropDownContent>
            }
        </DropDown>
  )
}

export default SelectOva

const DropDown = styled.div`
    width:80%;
    padding:8px;
    position: relative;
    z-index: 2;
`;
const DropDownButton = styled.div`
    padding:8px;
    font-weight:700;
    display:flex;
    align-items:center;
    justify-content:space-between;
    background-color:var(--color-gris-claro);
    border-radius:5px;
    border:2px solid var(--color-morado-oscuro);
    cursor: pointer;
    text-align:left;
`;
const DropDownContent = styled.div`
    box-sizing:border-box;
    box-shadow: 3px 3px 10px 6px rgba(0,0,0,0.05);
    width:95%;
    position: absolute;
    border-radius: 5px;
    margin-top:8px;
    background-color: var(--color-blanco);
    cursor: pointer;
    max-height:200px;
    overflow:auto;
`;
const DropDownItem = styled.div`
    box-sizing:border-box;
    padding:8px;
    text-align:left;
    :hover{
        background-color: var(--color-rosa);
        color: var(--color-blanco);
        transition: all 0.2s;
    }
    :nth-child(1){
        border-radius:5px 5px 0 0;
    }
    :last-child{
        border-radius: 0 0 5px 5px;
    }
`;
